import { Link, usePage } from '@inertiajs/react';
import { m } from 'framer-motion';
import {
    ClipboardList,
    History,
    Home,
    Plane,
    PlusCircle,
    User,
} from 'lucide-react';
import { cn } from '@/lib/utils';

export const tabs = [
    { name: 'Beranda', href: '/dashboard', icon: Home, key: 'dashboard' },
    {
        name: 'Riwayat',
        href: '/presensi',
        icon: History,
        key: 'presensi.index',
    },
    {
        name: 'Absen',
        href: '/presensi/rekam',
        icon: PlusCircle,
        key: 'presensi.create',
        isPrimary: true,
    },
    { name: 'Izin', href: '/izin', icon: ClipboardList, key: 'izin.index' },
    {
        name: 'Pulang',
        href: '/kepulangan',
        icon: Plane,
        key: 'kepulangan.index',
    },
];

export function BottomNav() {
    const { url } = usePage();

    function isActive(href: string): boolean {
        if (href === '/dashboard') {
            return url === '/dashboard';
        }

        if (href === '/presensi') {
            return (
                url.startsWith('/presensi') &&
                !url.startsWith('/presensi/rekam')
            );
        }

        return url.startsWith(href);
    }

    return (
        <div className="fixed bottom-8 left-1/2 z-50 w-[calc(100vw-3rem)] max-w-[400px] -translate-x-1/2 lg:hidden">
            <nav className="relative flex h-16 w-full items-center justify-between rounded-full border border-black/[0.08] bg-white/95 px-2 shadow-[0_8px_30px_rgb(0,0,0,0.12)] backdrop-blur-xl tap-highlight-none">
                {tabs.map((tab) => {
                    const active = isActive(tab.href);
                    const Icon = tab.icon;

                    if (tab.isPrimary) {
                        return (
                            <div key={tab.key} className="flex flex-1 justify-center">
                                <Link
                                    href={tab.href}
                                    className={cn(
                                        "relative flex h-12 w-12 items-center justify-center rounded-full transition-all duration-300",
                                        active 
                                            ? "bg-[#ffd709] text-[#5b4b00] shadow-[0_4px_15px_rgba(255,215,9,0.5)] scale-110" 
                                            : "bg-[#ffd709]/90 text-[#5b4b00] hover:bg-[#ffd709]"
                                    )}
                                >
                                    <Icon className="h-5 w-5" strokeWidth={1.5} />
                                </Link>
                            </div>
                        );
                    }

                    return (
                        <Link
                            key={tab.key}
                            href={tab.href}
                            prefetch={['mount', 'hover']}
                            instant
                            className={cn(
                                'relative flex flex-1 flex-col items-center justify-center h-full transition-all duration-500',
                                active ? 'text-[#006944]' : 'text-slate-400 hover:text-slate-600'
                            )}
                        >
                            <m.div
                                animate={{ y: active ? -2 : 0 }}
                                className="flex flex-col items-center justify-center gap-0.5"
                            >
                                <Icon
                                    className={cn(
                                        "h-5 w-5 transition-all duration-300",
                                        active ? "scale-110" : "scale-100"
                                    )}
                                    strokeWidth={1.5}
                                />
                                
                                {active && (
                                    <m.span
                                        initial={{ opacity: 0, y: 5 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        className="whitespace-nowrap font-sans text-[8px] font-black tracking-widest uppercase"
                                    >
                                        {tab.name}
                                    </m.span>
                                )}
                            </m.div>

                            {active && (
                                <m.div 
                                    layoutId="active-pill"
                                    className="absolute inset-0 z-[-1] rounded-full bg-emerald-50/50"
                                />
                            )}
                        </Link>
                    );
                })}
            </nav>
        </div>
    );
}
